import { render, staticRenderFns } from "./X-ajout-livraison.vue?vue&type=template&id=613b79f6"
import script from "./X-ajout-livraison.vue?vue&type=script&lang=js"
export * from "./X-ajout-livraison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('613b79f6')) {
      api.createRecord('613b79f6', component.options)
    } else {
      api.reload('613b79f6', component.options)
    }
    module.hot.accept("./X-ajout-livraison.vue?vue&type=template&id=613b79f6", function () {
      api.rerender('613b79f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/livraison/X-ajout-livraison.vue"
export default component.exports